<onyx-section [heading]="`${I18N}.heading`">
  <form [formGroup]="form()">
    @let controls = form().controls;

    <onyx-form-group [controls]="controls.selectedCategories">
      <onyx-dropdown
        [formControl]="controls.selectedCategories"
        label="labels.categories"
        [options]="categories()"
        [multiple]="true"
        [showErrors]="false"
        [size]="32"
      ></onyx-dropdown>

      <onyx-suggestions
        [control]="controls.selectedCategories"
        [suggestions]="CATEGORY_SUGGESTIONS"
        [multiple]="true"
      ></onyx-suggestions>
    </onyx-form-group>

    @for (categoryGroup of categoriesControl.controls; track categoryGroup) {
      @let category = categoryGroup.controls.category.value;
      <ng-container [formGroup]="categoryGroup">
        <onyx-datepicker
          [formControl]="categoryGroup.controls.expirationDate"
          label="{{ 'labels.expirationDate' | translate }} {{
            `${DictionaryCode.DRIVERS_LICENSE_CATEGORY}.${category}` | translate
          }}"
          [showIndefinite]="true"
          [indefiniteLabel]="`${I18N}.indefinitely` | translate"
          [yearsRange]="{ past: 0, future: 15 }"
          [warningTypes]="['pastDate']"
          [size]="32"
        ></onyx-datepicker>
      </ng-container>
    }

    @if (professionalQualificationsExpirationDateControl.enabled) {
      <onyx-datepicker
        [formControl]="professionalQualificationsExpirationDateControl"
        label="labels.professionalQualificationsExpirationDate"
        [yearsRange]="{ past: 0, future: 10 }"
        [warningTypes]="['pastDate']"
        [size]="32"
      ></onyx-datepicker>
    }

    <onyx-text-field
      class="drivers-license-number"
      [formControl]="controls.driversLicenseNumber"
      label="labels.driversLicenseNumber"
      textTransform="uppercase"
      [size]="32"
    ></onyx-text-field>

    <onyx-dropdown
      class="drivers-license-issuing-country"
      [formControl]="controls.driversLicenseIssuingCountry"
      label="labels.issuingCountry"
      [options]="countries$ | async"
      [optional]="true"
      [search]="true"
      [size]="32"
    ></onyx-dropdown>

    <onyx-upload
      class="drivers-license-scan"
      [formControl]="controls.scans"
      label="labels.driversLicenseScan"
      [size]="32"
      [limit]="2"
    ></onyx-upload>
  </form>
</onyx-section>
